module.exports = {
  "country": "FI",
  "artist": "Käärijä",
  "song": "Cha Cha Cha",
  "year": "2023",
  "place": "2",
  "spotify": "5RX8T3EoTuXcybAxe6oPAw"
};